import React, { useState } from 'react'
import { Button } from '@mui/material'
import SideNavGroups from '../SideNavGroups/SideNavGroups'
import SideNavContentTypes from '../SideNavContentTypes/SideNavContentTypes'
import SideNavModal from '../SideNavModal/SideNavModal'
import { checkDupes } from './SideNavHelpers'

// Export side nav button for qis.
export default function SideNavButtonQIs ({ audit, findingID, CAPAs, setSidePreviews, QICRSAC, QIESP, QILOC, QIDL }) {
  let auditTitle = ''
  let auditID = ''
  let capaString = ''
  const CAPAIDs = []
  const CRSACs = []
  const ESPs = []
  const LOCs = []
  const DLs = []
  // Set state to show modal.
  const [shouldShowModal, setShouldShowModal] = useState(false)
  // Set the content type.
  const [contentType, setContentType] = useState()
  // Set the content type title.
  const [contentTypeTitle, setContentTypeTitle] = useState()
  // Set the data to render.
  const [data, setData] = useState()
  // Check non-duplicate node and push it.
  const pushElement = (dataItem, type) => {
    dataItem.forEach(element => {
      if (element && checkDupes(element, type)) {
        type.push(element)
      }
    })
  }

  if (audit) {
    auditID = audit?.nid
    auditTitle = audit?.title
    // Push data for audit CRSAC.
    if (audit?.CRSAC) {
      pushElement(audit?.CRSAC, CRSACs)
    }
    // Push data for audit ESP.
    if (audit?.ESP) {
      pushElement(audit?.ESP, ESPs)
    }
    // Push data for audit LOC.
    if (audit?.LOC) {
      pushElement(audit?.LOC, LOCs)
    }
    // Push data for audit DL.
    if (audit?.DL) {
      pushElement(audit?.DL, DLs)
    }
  }
  if (CAPAs) {
    // Loop through all capas data.
    CAPAs.filter(n => n).forEach(item => {
      // Push data for capas CRSAC.
      if (item?.CRSAC) {
        pushElement(item?.CRSAC, CRSACs)
      }
      // Push data for capas ESP.
      if (item?.ESP) {
        pushElement(item?.ESP, ESPs)
      }
      // Push data for capas LOC.
      if (item?.LOC) {
        pushElement(item?.LOC, LOCs)
      }
      // Push data for capas DL.
      if (item?.DL) {
        pushElement(item?.DL, DLs)
      }
      CAPAIDs.push(item?.nid)
    })
  }
  capaString = CAPAIDs.filter(n => n).join(',')
  // Push data for qis CRSAC.
  if (QICRSAC) {
    pushElement(QICRSAC, CRSACs)
  }
  // Push data for qis ESP.
  if (QIESP) {
    pushElement(QIESP, ESPs)
  }
  // Push data for qis LOC.
  if (QILOC) {
    pushElement(QILOC, LOCs)
  }
  // Push data for qis DL.
  if (QIDL) {
    pushElement(QIDL, DLs)
  }
  // Return the side nav button for qis.
  return (
    <div className='side-nav-button'>
      <Button
        onClick={() => {
          setSidePreviews(
            <div className='side-wrapper--right-column'>
              <div className='sidebar-wrapper--right-column'>
                <SideNavContentTypes
                  contentType='Audit'
                  number={audit ? 1 : 0}
                  title={audit ? auditTitle : ''}
                  link={audit ? `/content/audits?id=${auditID}` : ''}
                />
                <SideNavContentTypes
                  contentType='Findings'
                  number={findingID ? 1 : 0}
                  link={findingID ? `/content/findings?id=${findingID}` : ''}
                />
                <SideNavContentTypes
                  contentType='CAPAs'
                  number={CAPAs.length}
                  link={`/content/capas?id=${capaString}`}
                />
                <SideNavGroups
                  contentType='CRSAC(s)'
                  data={CRSACs}
                  openModalCallback={() => {
                    setContentType('CRSAC')
                    setData(CRSACs)
                    setShouldShowModal(true)
                    setContentTypeTitle('CRSAC(s)')
                  }}
                />
                <SideNavGroups
                  contentType='ESP(s)'
                  data={ESPs}
                  openModalCallback={() => {
                    setContentType('ESP')
                    setData(ESPs)
                    setShouldShowModal(true)
                    setContentTypeTitle('ESP(s)')
                  }}
                />
                <SideNavGroups
                  contentType='LOC(s)'
                  data={LOCs}
                  openModalCallback={() => {
                    setContentType('LOC')
                    setData(LOCs)
                    setShouldShowModal(true)
                    setContentTypeTitle('LOC(s)')
                  }}
                />
                <SideNavGroups
                  contentType='DL(s)'
                  data={DLs}
                  openModalCallback={() => {
                    setContentType('DL')
                    setData(DLs)
                    setShouldShowModal(true)
                    setContentTypeTitle('DL(s)')
                  }}
                />
              </div>
            </div>
          )
        }}
      >
        Side Nav
      </Button>
      <SideNavModal
        isOpen={shouldShowModal}
        onClose={() => setShouldShowModal(false)}
        data={data}
        contentType={contentType}
        contentTypeTitle={contentTypeTitle}
      />
    </div>

  )
}
